import LogRoutes from './logs/routes'
import TenantRoutes from './tenant/routes'
import StaffRoutes from './staff/routes'
import RolesRoutes from './roles/routes'
import { Permission } from '@/lib/permissions/v1'

export default {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/Index.vue'),
    meta: {
        auth: true,
        label: 'Administration',
        breadcrumb: false,
    },
    children: [
        LogRoutes,
        RolesRoutes,
        StaffRoutes,
        TenantRoutes,
        {
            path: 'sent-emails',
            component: () => import('@/views/admin/Index.vue'),
            meta: {
                auth: true,
                label: 'Sent Emails',
                breadcrumb: false,
            },
            children: [
                {
                    path: '',
                    name: 'system.sent-emails.index',
                    component: () => import('@/views/admin/sent-email/Index.vue'),
                    meta: {
                        label: 'Sent Emails',
                        auth: true,
                        permission: Permission.SentEmailViewAny,
                    },
                },
            ],
        },
    ],
}
